import {queries} from '@cypro/engine/queries'
import {useZero as useZeroClient} from '@rocicorp/zero/react'

/**
 * One-off lookup of the patients a scanned wristband hospital ID may belong to; waits for the server result.
 * Results over-match (see `findPatientsByIdentifiers`); confirm them with `matchWristbandScan`.
 */
export function useFindPatientsByHospitalId() {
  // the app's useZero spreads the client into a plain object, which drops prototype methods like run()
  const zero = useZeroClient()

  return function find(hospitalId: string) {
    const trimmed = hospitalId.trim()
    if (!trimmed) return Promise.resolve([])
    return zero.run(queries.patients.findPatientsByIdentifiers({hospitalPatientId: trimmed}), {type: 'complete'})
  }
}
